import type { PrinceAttachment } from './types';
import { ChatCanvasIcon } from './ChatCanvasIcon';
import { useTranslation } from 'react-i18next';
import { useRelativeTime } from '@/hooks/useRelativeTime';

interface ChatAttachmentProps {
  attachment: PrinceAttachment;
  onClick: () => void;
}

export function ChatAttachment({ attachment, onClick }: ChatAttachmentProps) {
  const { t } = useTranslation('prince');
  const { getRelativeTime } = useRelativeTime();

  return (
    <button
      onClick={onClick}
      className="inline-flex items-center gap-4 py-3 px-4 bg-white border border-gray-200 rounded-md shadow-sm hover:bg-gray-50 hover:border-gray-300 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      type="button"
    >
      <ChatCanvasIcon />

      {/* Document Info */}
      <div className="flex-1 min-w-0 text-left">
        <div className="text-sm font-medium text-gray-900 truncate">{attachment.name}</div>
        {attachment.lastModified && (
          <div className="text-xs text-gray-500">
            {t('messages.lastEdit', { time: getRelativeTime(new Date(attachment.lastModified)) })}
          </div>
        )}
      </div>
    </button>
  );
}
